// Faithful port of eb-ui `packages/eds/eds-share-box/src/EmailShare.jsx`.
// The mailto: URL construction (url-lib formatUrl + gettext subject) is the
// wire — byte-matched against the eb-ui source by ShareBox.urls.test.ts.
import React from 'react';
import { formatUrl } from 'url-lib';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { MailFillChunky } from '@eventbrite/legacy-eds.iconography';
import { gettext } from '../../i18n/gettext';
import { EMAIL_AFFILIATED_CODE } from './constants';
import { openUrl } from './utils';
import type { BaseShareProps, EmailOptions, UtmOptions } from './types';

const _getMailToUrl = (
    eventName: string,
    eventUrl: string,
    affiliateChannel: string | undefined,
    utmOptions: UtmOptions | undefined,
    emailOptions: EmailOptions = {},
) => {
    let subject = gettext("You're invited to %(eventName)s", {
        eventName,
    });

    let body = formatUrl(eventUrl, {
        aff:
            (affiliateChannel && EMAIL_AFFILIATED_CODE[affiliateChannel]) ||
            EMAIL_AFFILIATED_CODE['default'],
        ...utmOptions,
    });

    if (emailOptions.subject) {
        subject = emailOptions.subject;
    }

    if (emailOptions.body) {
        body = emailOptions.body;
    }

    return formatUrl('mailto:', {
        subject,
        body,
    });
};

export interface EmailShareProps extends BaseShareProps {
    emailOptions?: EmailOptions;
    trackingCode?: string;
}

export default class EmailShare extends React.Component<EmailShareProps> {
    _handleButtonClick() {
        const {
            affiliateChannel,
            emailOptions,
            eventName,
            eventUrl,
            onClick,
            utmOptions,
        } = this.props;
        const url = _getMailToUrl(
            eventName,
            eventUrl,
            affiliateChannel,
            utmOptions,
            emailOptions,
        );

        if (onClick) {
            onClick();
        }

        openUrl(url);
    }

    render() {
        return (
            <span
                className="eds-l-pad-right-1"
                data-spec="email-share-box-container"
                data-heap-id={this.props.dataHeapId}
                data-share-method={this.props.shareMethod}
                data-page-area={this.props.dataPageArea}
                data-event-id={this.props.eventId}
            >
                <IconButton
                    iconType={<MailFillChunky />}
                    title={gettext('Share by Email')}
                    onClick={this._handleButtonClick.bind(this)}
                />
            </span>
        );
    }
}
